import DocumentDetailField from '@containers/form-i9/document-details-list/detail-field';
import { FadeableFieldCheckbox } from '@containers/form-i9/document-details-list/styles';
import { getDocumentDetailsListTranslations } from '@containers/form-i9/document-details-list/translations';
import { PrefilledFormField } from '@containers/form-i9/styles';
import { FieldType } from '@models/field-builder/field-type';
import { ISection2DocumentDetails } from '@models/onboarding-review/section2-document-details';
import {
    DateFormatTemplate,
    formatAsLocalTimezone
} from '@utils/date-format';
import {
    Observer,
    observer
} from 'mobx-react';
import * as React from 'react';

export const ExpiryDateField: React.FunctionComponent<{
    showCheckbox: boolean;
    details?: ISection2DocumentDetails;
    showLabel?: boolean;
    hasError?: boolean;
    hideNoExpiryDate?: boolean;
    renderField?: (text: string, placeholder: string, value?: string | null, hasError?: boolean) => React.ReactNode;
    onNoExpiryDateToggled?: (enabled: boolean) => void;
}> = observer(props => {
    const {
        renderField = text => <PrefilledFormField>{text}</PrefilledFormField>,
        onNoExpiryDateToggled
    } = props;

    const translations = getDocumentDetailsListTranslations();

    // document detail fields can be simplified later
    const transformExpiryDate = (value?: string | null) => {
        if (value === undefined || value === '') {
            return value;
        }

        if (value === null) {
            return translations.expiryDatePlaceholder;
        }

        return formatAsLocalTimezone(value, DateFormatTemplate.MonthFirstCalendarDate);
    };
    const cannotReadDetails = props.details === undefined;

    return (
        <DocumentDetailField details={props.details}
                             fieldName={'expiryDate'}
                             transformValue={transformExpiryDate}
                             renderFieldContent={(expiryDateText: string, placeholder: string, value?: string | null) => {
                                 const fieldValue = props.details?.expiryDate === '' ?
                                     null :
                                     value;
                                 return (
                                     <React.Fragment>
                                         { props.hideNoExpiryDate && renderField(expiryDateText, placeholder, fieldValue, props.hasError)}
                                         {
                                             props.showCheckbox ? (
                                                 <Observer>
                                                     {
                                                         () => {
                                                             return (
                                                                <React.Fragment>
                                                                                    <FadeableFieldCheckbox type={FieldType.CHECKBOX}
                                                                                        id={'no-expiry-date'}
                                                                                        faded={cannotReadDetails}
                                                                                        value={props.details?.isExpiryNaCheckboxChecked}
                                                                                        label={translations.noExpirationDateLabel}
                                                                                        setValueMethod={onNoExpiryDateToggled}
                                                                                        disabled={cannotReadDetails}/>
                                                                </React.Fragment>
                                                                 
                                                             );
                                                         }
                                                     }
                                                 </Observer>
                                             ) : null
                                         }
                                     </React.Fragment>
                                 );
                             }}
                             label={props.showLabel ? translations.expirationDateLabel : undefined}
                             placeholder={translations.expiryDatePlaceholder}/>
    );
});



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/expiry-date-field.tsx